module.exports = __webpack_public_path__ + "img/SEND.f7ee7b52.svg";